/**
 * Community, `/community` (TMMAPP-0152 §C 18; prototype P:315–322, state 23): a designed Coming soon
 * page — the Operator's decision is that Community shows no made-up content, so nothing of the
 * prototype's For You, Groups, Monthly calls or Events (no tabs, leaders, prices, groups or events)
 * is drawn. The header is the `h1`, the prototype's lead and, at its right, "You appear as {name}"
 * on the lavender Community wash (13 / 500, 6 × 12, a pill, no icon; the name is the top bar's
 * context name, "Charles R."). One card says "Coming soon" with the line of what is being built,
 * and **Tell me when it's ready** opens the shared Coming soon dialog (`useComingSoon`).
 */
import { Box, Button, Paper, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMe } from '@/session/meHooks';
import { contextNameOf } from '@/shell/initials';
import { PageHeader } from '@/shell/PageHeader';
import { privacyColours } from '@/shell/privacyColours';
import { useComingSoon } from '@/shell/useComingSoon';
import { usePageTitle } from '@/shell/usePageTitle';
import { PILL_RADIUS, resolveTokens } from '@/theme';

export function CommunityPage() {
  const { t } = useTranslation();
  const me = useMe();
  const tokens = resolveTokens(useTheme());
  const comingSoon = useComingSoon();
  const title = usePageTitle({ title: t('community.title') });
  const { background, ink } = privacyColours('community', tokens);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
      <PageHeader
        title={title}
        subtitle={t('community.lead')}
        actions={
          <Box
            component="span"
            data-community-chip=""
            sx={{
              display: 'inline-flex',
              maxWidth: '100%',
              p: '6px 12px',
              borderRadius: `${PILL_RADIUS}px`,
              bgcolor: background,
              color: ink,
              fontSize: 13,
              lineHeight: '20px',
              fontWeight: 500,
              overflowWrap: 'anywhere',
            }}
          >
            {t('community.youAppearAs', { name: contextNameOf(me.user.displayName) })}
          </Box>
        }
      />
      <Paper data-coming-soon="" sx={{ p: '24px', maxWidth: 620 }}>
        <Typography variant="h3" component="h2">
          {t('comingSoon.title')}
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary' }}>
          {t('community.body')}
        </Typography>
        <Button
          variant="contained"
          onClick={comingSoon.open}
          sx={{ mt: 2.5, textTransform: 'none', fontWeight: 600, borderRadius: '12px', px: '18px' }}
        >
          {t('community.notify')}
        </Button>
      </Paper>
      {comingSoon.node}
    </Box>
  );
}
